import { mapGetters, mapActions } from 'vuex';
export default {
    name: 'searchAdsAgentConnection',
    inject: ['$eventBus'],
    props: {
        theme: {
            type: String,
            default: 'msp-banner',
        }
    },
    computed: {
        ...mapGetters('glb', ['glb']),
    },
    methods: {
        openConnectAgentHotlead() {
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtHotleadForm',
                trigger: this.$options.name,
                opt: {
                    hotleadTitle: 'Connect with an agent',
                    hotleadSub: 'We\'ll connect you to a local real estate agent who can answer your question on this or any other property.',
                    hotleadType: 'AgentConnectionTile',
                    buttonText: this.molang('dpp.hotleadForm.submit'),
                    showComment: false,
                    showZipcode: true,
                    ojoFormConfigs: {
                        showCtaLinks: true,
                        showDisclaimer: false
                    },
                },
            });
        }
    }
};
